<script>
import { defineAsyncComponent } from 'vue'

export default {
    name: 'AnalyzesLineChartAsync',

    components: {
        AnalyzesLineChart: defineAsyncComponent(() => import('./AnalyzesLineChart.vue'))
    },
    
    props: {
        chartData: {
            type: Object,
            required: true
        }
    }
}
</script>


<template>
    <Suspense>
        <template #default>
            <AnalyzesLineChart :chart-data="chartData" />
        </template>
    </Suspense>    
</template>